//@ts-nocheck
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BestEmployeesResponse {
  fullName?: string | null
  /** @format int32 */
  rank?: number | null
  position?: string | null
  imageUrl?: string | null
}

export interface GetAnnouncementDetailResponse {
  id?: string | null
  name?: string | null
  content?: string | null
  /** @format date-time */
  date?: string | null
}

export interface GetAnnouncementsListResponse {
  id?: string | null
  name?: string | null
  tags?: string | null
  /** @format date-time */
  date?: string | null
}

export interface GetAnnouncementsListResponsePaginationResponse {
  items?: GetAnnouncementsListResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface GetAnnouncementsResponse {
  id?: string | null
  name?: string | null
  /** @format date-time */
  date?: string | null
}

export interface GetBestTeamsResponse {
  teamName?: string | null
  teamId?: string | null
  imageUrl?: string | null
  /** @format int32 */
  rank?: number | null
  time?: string | null
}

export interface GetBestsOfSetadiResponse {
  name?: string | null
  systemUserId?: string | null
  domain?: string | null
  imageUrl?: string | null
  position?: string | null
  /** @format int32 */
  rank?: number | null
}

export interface GetFactorHayeGoruhiVaBartarinhaResponse {
  salePerson?: string | null
  domain?: string | null
  imageUrl?: string | null
  /** @format int32 */
  teamCount?: number
  /** @format int32 */
  invoiceCount?: number
  /** @format uuid */
  expertId?: string
}

export interface GetMagazineDetailResponse {
  id?: string | null
  name?: string | null
  /** @format date-time */
  date?: string | null
  type?: string | null
  content?: string | null
}

export interface GetMagazinesResponse {
  id?: string | null
  name?: string | null
  /** @format date-time */
  date?: string | null
  type?: string | null
}

export interface GetMahHayePoursantMoredeTaeedAstResponse {
  title?: string | null
  goalName?: string | null
}

export interface GetMaheJariPoursantMoredeTaeedAstDetailResponse {
  invoicenumber?: string | null
  new_mainteamname?: string | null
  /** @format double */
  first_profit?: number
  /** @format double */
  delay?: number
  /** @format double */
  cost?: number
  /** @format double */
  final_Profit?: number
  new_shamsisettlementdate?: string | null
  /** @format double */
  new_totalamountoforf?: number
  new_shamsi_accounting_date?: string | null
  /** @format date-time */
  new_accounting_date?: string
  new_invoice_url?: string | null
  new_subsidiaryname?: string | null
}

export interface GetMaheJariPoursantMoredeTaeedAstResponse {
  /** @format double */
  profit?: number
  new_mainteamname?: string | null
}

export interface GetMaheJariPoursantMoredeTaeedNistDetailResponse {
  new_mainteamName?: string | null
  invoiceNumber?: string | null
  new_shamsi_accounting_date?: string | null
  new_shamsisettlementdate?: string | null
  status_reason?: string | null
  new_invoice_url?: string | null
}

export interface GetNearestBirthDaysResponse {
  fullName?: string | null
  imageUrl?: string | null
  shamsiBirthDay?: string | null
  shamsiEntryDate?: string | null
  isBirthDay?: boolean
  isEnterDate?: boolean
  isNearBirthDay?: boolean
  isNearEntryDate?: boolean
}

export interface GetNemudarCoordinatorAndBestsResponse {
  year?: string | null
  month?: string | null
  type?: string | null
  /** @format int32 */
  count?: number
  person?: string | null
  domain?: string | null
  imageUrl?: string | null
  /** @format uuid */
  systemUserId?: string
  /** @format int32 */
  grade?: number
}

export interface GetOrganizationUserResponse {
  name?: string | null
  /** @format uuid */
  positionId?: string
  user?: User
  children?: GetOrganizationUserResponse[] | null
}

export interface GetPerformancesListResponse {
  creatorName?: string | null
  creatorImageUrl?: string | null
  expertName?: string | null
  expertImageUrl?: string | null
  /** @format date-time */
  date?: string | null
  description?: string | null
  type?: string | null
}

export interface GetPerformancesListResponsePaginationResponse {
  items?: GetPerformancesListResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

export interface GetShakhesHayeAmalkardResponse {
  fullName?: string | null
  positionIdName?: string | null
  /** @format double */
  finalScore?: number
  /** @format int32 */
  grade?: number
  /** @format int32 */
  positionGrade?: number
  domainName?: string | null
  /** @format uuid */
  expertId?: string
  imageUrl?: string | null
}

export interface GetSoodBarAsaseTeamResponse {
  /** @format uuid */
  new_Main_Team?: string
  new_Main_TeamName?: string | null
  /** @format double */
  sum_new_final_estimated_profit?: number
  /** @format int32 */
  count?: number
  /** @format int32 */
  invoiceCount?: number
  shamsi_date?: string | null
}

export interface GetSoodVaTedadeFactoreTeamResponse {
  date?: string | null
  /** @format uuid */
  teamId?: string
  teamName?: string | null
  /** @format double */
  estimatedProfit?: number
  /** @format date-time */
  lastUpdate?: string
  /** @format int32 */
  invoiceCount?: number
}

export interface GetSoodeKolBarAsasTarikhTasfieResponse {
  type?: string | null
  month?: string | null
  /** @format double */
  total?: number
}

export interface GetStoriesResponse {
  id?: string | null
  url?: string | null
}

export interface GetStoryItemsResponse {
  id?: string | null
  url?: string | null
  description?: string | null
  title?: string | null
  /** @format int32 */
  sequence?: number | null
}

export interface GetTeamWeightAndTargetResponse {
  /** @format uuid */
  new_mainteam?: string
  new_mainteamName?: string | null
  /** @format double */
  new_quantity_kg?: number
  /** @format double */
  sum_new_final_estimated_profit?: number
  /** @format int32 */
  count?: number
  /** @format int32 */
  invoiceCount?: number
  /** @format double */
  target?: number
}

export interface GetTonajBarAsaseTeamResponse {
  /** @format uuid */
  new_Main_Team?: string
  new_Main_TeamName?: string | null
  shamsi_date?: string | null
  /** @format double */
  new_quantity_kg?: number
  /** @format double */
  target?: number
}

export interface GetTonajeForusheTeamResponse {
  date?: string | null
  /** @format uuid */
  teamId?: string
  teamName?: string | null
  /** @format double */
  quantityKg?: number
  /** @format double */
  target?: number
}

export interface GetUsefulPhoneNumbersResponse {
  cafe?: string | null
  security?: string | null
  superMarket?: string | null
}

export interface GetUserInfoResponse {
  vacationWithSalary?: string | null
  vacationWithoutSalary?: string | null
  remainingVacation?: string | null
  totalFunctionality?: string | null
  workDeficit?: string | null
}

export interface GetUserNotificationsResponse {
  title?: string | null
  fullName?: string | null
  relatedTo?: string | null
  /** @format date-time */
  createdOn?: string | null
  /** @format uuid */
  objectId?: string | null
  entityName?: string | null
  label?: string | null
  webUrl?: string | null
  appUrl?: string | null
}

export interface Requester {
  /** @format uuid */
  id?: string
  fullName?: string | null
  domainName?: string | null
  team?: string | null
  /** @format uuid */
  teamId?: string | null
  position?: string | null
  extension?: string | null
  mobilePhoneNumber?: string | null
  email?: string | null
  imageUrl?: string | null
}

export interface SearchThroughUsersWithTheirManagerResponse {
  id?: string | null
  managerFullName?: string | null
  position?: string | null
  fullName?: string | null
  imageUrl?: string | null
  internalPhoneNumber?: string | null
}

export interface User {
  fullName?: string | null
  imageUrl?: string | null
  teamType?: string | null
  /** @format uuid */
  userId?: string
}

export interface UsersResponse {
  id?: string | null
  position?: string | null
  team?: string | null
  internalPhoneNumber?: string | null
  fullName?: string | null
  managerFullName?: string | null
  joiningDate?: string | null
  email?: string | null
  location?: string | null
  imageUrl?: string | null
  mobilePhoneNumber?: string | null
}

export interface UsersResponsePaginationResponse {
  items?: UsersResponse[] | null
  /** @format int32 */
  totalCount?: number | null
  /** @format int32 */
  currentPage?: number | null
  /** @format int32 */
  pageSize?: number | null
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '/home' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title Ahanonline.App
 * @version 1.0
 * @baseUrl /home
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  announcements = {
    /**
     * No description
     *
     * @tags Announcements
     * @name GetAnnouncementsList
     * @request GET:/Announcements/GetAnnouncements
     * @secure
     */
    getAnnouncementsList: (params: RequestParams = {}) =>
      this.request<GetAnnouncementsResponse[], any>({
        path: `/Announcements/GetAnnouncements`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name GetAnnouncementsListList
     * @request GET:/Announcements/GetAnnouncementsList
     * @secure
     */
    getAnnouncementsListList: (
      query?: {
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
        /** @format date-time */
        fromDate?: string
        /** @format date-time */
        toDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetAnnouncementsListResponsePaginationResponse, any>({
        path: `/Announcements/GetAnnouncementsList`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Announcements
     * @name GetAnnouncementDetailList
     * @request GET:/Announcements/GetAnnouncementDetail
     * @secure
     */
    getAnnouncementDetailList: (
      query?: {
        id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetAnnouncementDetailResponse, any>({
        path: `/Announcements/GetAnnouncementDetail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  bestEmployees = {
    /**
     * No description
     *
     * @tags BestEmployees
     * @name GetBestSetadiEmployeesList
     * @request GET:/BestEmployees/GetBestSetadiEmployees
     * @secure
     */
    getBestSetadiEmployeesList: (params: RequestParams = {}) =>
      this.request<BestEmployeesResponse[], any>({
        path: `/BestEmployees/GetBestSetadiEmployees`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BestEmployees
     * @name GetBestBaazarganiEmployeesList
     * @request GET:/BestEmployees/GetBestBaazarganiEmployees
     * @secure
     */
    getBestBaazarganiEmployeesList: (params: RequestParams = {}) =>
      this.request<BestEmployeesResponse[], any>({
        path: `/BestEmployees/GetBestBaazarganiEmployees`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  charts = {
    /**
     * No description
     *
     * @tags Charts
     * @name GetBestsOfKpiList
     * @request GET:/Charts/GetBestsOfKpi
     * @secure
     */
    getBestsOfKpiList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetShakhesHayeAmalkardResponse[], any>({
        path: `/Charts/GetBestsOfKpi`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetBestsOfSetadiList
     * @request GET:/Charts/GetBestsOfSetadi
     * @secure
     */
    getBestsOfSetadiList: (
      query: {
        Date: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetBestsOfSetadiResponse[], any>({
        path: `/Charts/GetBestsOfSetadi`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetBestTeamsList
     * @request GET:/Charts/GetBestTeams
     * @secure
     */
    getBestTeamsList: (
      query: {
        Date: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetBestTeamsResponse[], any>({
        path: `/Charts/GetBestTeams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetFactorHayeGoruhiVaBartarinhaList
     * @request GET:/Charts/GetFactorHayeGoruhiVaBartarinha
     * @secure
     */
    getFactorHayeGoruhiVaBartarinhaList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetFactorHayeGoruhiVaBartarinhaResponse[], any>({
        path: `/Charts/GetFactorHayeGoruhiVaBartarinha`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetMaheJariPoursantMoredeTaeedAstDetailList
     * @request GET:/Charts/GetMaheJariPoursantMoredeTaeedAstDetail
     * @secure
     */
    getMaheJariPoursantMoredeTaeedAstDetailList: (
      query?: {
        Search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetMaheJariPoursantMoredeTaeedAstDetailResponse[], any>({
        path: `/Charts/GetMaheJariPoursantMoredeTaeedAstDetail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetMaheJariPoursantMoredeTaeedNistDetailList
     * @request GET:/Charts/GetMaheJariPoursantMoredeTaeedNistDetail
     * @secure
     */
    getMaheJariPoursantMoredeTaeedNistDetailList: (
      query?: {
        Search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetMaheJariPoursantMoredeTaeedNistDetailResponse[], any>({
        path: `/Charts/GetMaheJariPoursantMoredeTaeedNistDetail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetMahHayePoursantMoredeTaeedAstList
     * @request GET:/Charts/GetMahHayePoursantMoredeTaeedAst
     * @secure
     */
    getMahHayePoursantMoredeTaeedAstList: (params: RequestParams = {}) =>
      this.request<GetMahHayePoursantMoredeTaeedAstResponse[], any>({
        path: `/Charts/GetMahHayePoursantMoredeTaeedAst`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetNemudarCoordinatorAndBestsList
     * @request GET:/Charts/GetNemudarCoordinatorAndBests
     * @secure
     */
    getNemudarCoordinatorAndBestsList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetNemudarCoordinatorAndBestsResponse[], any>({
        path: `/Charts/GetNemudarCoordinatorAndBests`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetPoursantMoredeTaeedAstList
     * @request GET:/Charts/GetPoursantMoredeTaeedAst
     * @secure
     */
    getPoursantMoredeTaeedAstList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetMaheJariPoursantMoredeTaeedAstResponse[], any>({
        path: `/Charts/GetPoursantMoredeTaeedAst`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetShakhesHayeAmalkardList
     * @request GET:/Charts/GetShakhesHayeAmalkard
     * @secure
     */
    getShakhesHayeAmalkardList: (params: RequestParams = {}) =>
      this.request<GetShakhesHayeAmalkardResponse, any>({
        path: `/Charts/GetShakhesHayeAmalkard`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetSoodBarAsaseTeamList
     * @request GET:/Charts/GetSoodBarAsaseTeam
     * @secure
     */
    getSoodBarAsaseTeamList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetSoodBarAsaseTeamResponse[], any>({
        path: `/Charts/GetSoodBarAsaseTeam`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetSoodeKolBarAsasTarikhFactorList
     * @request GET:/Charts/GetSoodeKolBarAsasTarikhFactor
     * @secure
     */
    getSoodeKolBarAsasTarikhFactorList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetSoodeKolBarAsasTarikhTasfieResponse[], any>({
        path: `/Charts/GetSoodeKolBarAsasTarikhFactor`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetSoodeKolBarAsasTarikhTasfieList
     * @request GET:/Charts/GetSoodeKolBarAsasTarikhTasfie
     * @secure
     */
    getSoodeKolBarAsasTarikhTasfieList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetSoodeKolBarAsasTarikhTasfieResponse[], any>({
        path: `/Charts/GetSoodeKolBarAsasTarikhTasfie`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetSoodeMabnayePoursantList
     * @request GET:/Charts/GetSoodeMabnayePoursant
     * @secure
     */
    getSoodeMabnayePoursantList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/Charts/GetSoodeMabnayePoursant`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetSoodVaTedadeFactoreTeamList
     * @request GET:/Charts/GetSoodVaTedadeFactoreTeam
     * @secure
     */
    getSoodVaTedadeFactoreTeamList: (
      query?: {
        /** @format uuid */
        TeamId?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetSoodVaTedadeFactoreTeamResponse, any>({
        path: `/Charts/GetSoodVaTedadeFactoreTeam`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetTeamWeightAndTargetList
     * @request GET:/Charts/GetTeamWeightAndTarget
     * @secure
     */
    getTeamWeightAndTargetList: (params: RequestParams = {}) =>
      this.request<GetTeamWeightAndTargetResponse, any>({
        path: `/Charts/GetTeamWeightAndTarget`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetTonajBarAsaseTeamList
     * @request GET:/Charts/GetTonajBarAsaseTeam
     * @secure
     */
    getTonajBarAsaseTeamList: (
      query?: {
        ShamsiDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetTonajBarAsaseTeamResponse[], any>({
        path: `/Charts/GetTonajBarAsaseTeam`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Charts
     * @name GetTonajeForusheTeamList
     * @request GET:/Charts/GetTonajeForusheTeam
     * @secure
     */
    getTonajeForusheTeamList: (params: RequestParams = {}) =>
      this.request<GetTonajeForusheTeamResponse, any>({
        path: `/Charts/GetTonajeForusheTeam`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  ets = {
    /**
     * No description
     *
     * @tags Ets
     * @name UserInfoList
     * @request GET:/Ets/UserInfo
     * @secure
     */
    userInfoList: (params: RequestParams = {}) =>
      this.request<GetUserInfoResponse, any>({
        path: `/Ets/UserInfo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ets
     * @name GetEts
     * @request GET:/Ets
     * @secure
     */
    getEts: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Ets`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  fileStorage = {
    /**
     * No description
     *
     * @tags FileStorage
     * @name UploadCreate
     * @request POST:/FileStorage/Upload
     * @secure
     */
    uploadCreate: (
      data: {
        /** @format binary */
        file?: File
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/FileStorage/Upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileStorage
     * @name UploadSelfProfileCreate
     * @request POST:/FileStorage/UploadSelfProfile
     * @secure
     */
    uploadSelfProfileCreate: (
      data: {
        /** @format binary */
        file?: File
      },
      query?: {
        requester?: Requester
      },
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/FileStorage/UploadSelfProfile`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  }
  magazines = {
    /**
     * No description
     *
     * @tags Magazines
     * @name GetMagazinesList
     * @request GET:/Magazines/GetMagazines
     * @secure
     */
    getMagazinesList: (params: RequestParams = {}) =>
      this.request<GetMagazinesResponse[], any>({
        path: `/Magazines/GetMagazines`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Magazines
     * @name GetMagazineDetailList
     * @request GET:/Magazines/GetMagazineDetail
     * @secure
     */
    getMagazineDetailList: (
      query?: {
        Id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetMagazineDetailResponse, any>({
        path: `/Magazines/GetMagazineDetail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name GetUserNotificationsList
     * @request GET:/Notifications/GetUserNotifications
     * @secure
     */
    getUserNotificationsList: (params: RequestParams = {}) =>
      this.request<GetUserNotificationsResponse[], any>({
        path: `/Notifications/GetUserNotifications`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetNearestOccasionsList
     * @request GET:/Notifications/GetNearestOccasions
     * @secure
     */
    getNearestOccasionsList: (params: RequestParams = {}) =>
      this.request<GetNearestBirthDaysResponse[], any>({
        path: `/Notifications/GetNearestOccasions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  organizationInfo = {
    /**
     * No description
     *
     * @tags OrganizationInfo
     * @name GetUsefulPhoneNumbersList
     * @request GET:/OrganizationInfo/GetUsefulPhoneNumbers
     * @secure
     */
    getUsefulPhoneNumbersList: (params: RequestParams = {}) =>
      this.request<GetUsefulPhoneNumbersResponse, any>({
        path: `/OrganizationInfo/GetUsefulPhoneNumbers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationInfo
     * @name GetOrganizationChartList
     * @request GET:/OrganizationInfo/GetOrganizationChart
     * @secure
     */
    getOrganizationChartList: (params: RequestParams = {}) =>
      this.request<GetOrganizationUserResponse, any>({
        path: `/OrganizationInfo/GetOrganizationChart`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  performances = {
    /**
     * No description
     *
     * @tags Performances
     * @name GetPerformancesList
     * @request GET:/Performances/GetPerformances
     * @secure
     */
    getPerformancesList: (params: RequestParams = {}) =>
      this.request<GetPerformancesListResponse[], any>({
        path: `/Performances/GetPerformances`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Performances
     * @name GetPerformancesListList
     * @request GET:/Performances/GetPerformancesList
     * @secure
     */
    getPerformancesListList: (
      query: {
        /** @format date-time */
        FromDate: string
        /** @format date-time */
        ToDate: string
        Search?: string
        Type?: boolean
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<GetPerformancesListResponsePaginationResponse, any>({
        path: `/Performances/GetPerformancesList`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  stories = {
    /**
     * No description
     *
     * @tags Stories
     * @name StoriesList
     * @request GET:/Stories
     * @secure
     */
    storiesList: (params: RequestParams = {}) =>
      this.request<GetStoriesResponse[], any>({
        path: `/Stories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stories
     * @name StoriesDetail
     * @request GET:/Stories/{id}
     * @secure
     */
    storiesDetail: (id: string, params: RequestParams = {}) =>
      this.request<GetStoryItemsResponse[], any>({
        path: `/Stories/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  test = {
    /**
     * No description
     *
     * @tags Test
     * @name PostTest
     * @request POST:/Test/1
     * @secure
     */
    postTest: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Test/1`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name PostTest2
     * @request POST:/Test/2
     * @originalName postTest
     * @duplicate
     * @secure
     */
    postTest2: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Test/2`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name SearchThroughUsersWithChildrenList
     * @request GET:/Users/SearchThroughUsersWithChildren
     * @secure
     */
    searchThroughUsersWithChildrenList: (
      query: {
        Search: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchThroughUsersWithTheirManagerResponse[], any>({
        path: `/Users/SearchThroughUsersWithChildren`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersDetail
     * @request GET:/Users/{id}
     * @secure
     */
    usersDetail: (id: string, params: RequestParams = {}) =>
      this.request<UsersResponse, any>({
        path: `/Users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersList
     * @request GET:/Users
     * @secure
     */
    usersList: (
      query?: {
        Search?: string
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        CurrentPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<UsersResponsePaginationResponse, any>({
        path: `/Users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
}
